import { useContext } from 'react';
import GlobalContext from '../contexts/globalContext';

const useSettings = () => useContext(GlobalContext);

export default useSettings;
